export default "__VITE_ASSET__CxoNro4p__"